import {GetSelected, SetSelected} from "../tableHandler/manipulateTable";
import $ from "jquery";

export function MergeUniquely(arr1, arr2){
    return [...new Set([].concat(...[arr1? arr1: [], arr2? arr2: []]))]
}

export function GetSelectedFeaturesOfMap(){
    return JSON.parse(localStorage.getItem("selectedFeatures"));
}

export function GetSelectedFeatureIdsOfMap(){
    const features = GetSelectedFeaturesOfMap();
    const ids = [];
    for (const feature of features) {
        ids.push(feature.properties.identification);
    }
    return ids
}

export function DropFromSetSelectedButtonIdsIfSelected(_this){
    if($(_this).attr('class').includes('selected')){
        const index = window.$set_selected_button_selected_ids.indexOf($(_this).attr("rowId"));
        if (index !== -1) {
            window.$set_selected_button_selected_ids.splice(index, 1);
        }
    }
}
